import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form';
import ControlSwitch from '@/Shared/Form/ControlSwitch';
import Input from '@/Shared/Form/Input';

const DecisionMaking = () => {
  const { control } = useFormContext();
  const isSelected = useWatch({ name: 'isDecisionMaking', control });

  return (
    <React.Fragment>
      <div className="mb-3">
        <ControlSwitch
          labelOff='No'
          labelOn='Yes'
          name='isDecisionMaking'
        />
      </div>
      {
        isSelected && (
          <React.Fragment>
            <div className='mb-3'>
              <Input
                isRequired
                labelText='Purpose of automated decision making'
                name='decisionMakingPurpose'
                type='text'
                placeholder='Analyze your interactions on our website to enhance user experience'
              />
            </div>
            <div className='mb-3'>
              <Input
                isRequired
                labelText='How your automated decision-making works'
                name='decisionMakingHowWorks'
                type='text'
                placeholder='We use algorithms to assess user behavior and detect risks automatically'
              />
            </div>
            <div className='mb-3'>
              <Input
                isRequired
                labelText='How how these decisions may affect users'
                name='decisionMakingHowAffects'
                type='text'
                placeholder='You may face limits or checks based on automated decisions, but can request a review'
              />
            </div>
          </React.Fragment>
        )
      }
    </React.Fragment>
  )
}

export default DecisionMaking